(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9897],{

/***/ 65342:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"consolidatedGroupsLines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validIn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleTimeInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"validIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validIn"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weeklyTargets"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oee2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oee3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tcu"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":314}}');
    doc.loc.source = JSON.parse('{"body":"query consolidatedGroupsLines($validIn: ScheduleTimeInput!) {\\n  user {\\n    groups {\\n      id\\n      name\\n      lines {\\n        id\\n        name\\n        schedule(validIn: $validIn) {\\n          weeklyTargets {\\n            oee\\n            oee2\\n            oee3\\n            tcu\\n          }\\n        }\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.consolidatedGroupsLines = oneQuery(doc, "consolidatedGroupsLines");
        


/***/ }),

/***/ 92051:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lineConsolidatedOEE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeScrap"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consolidatedData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeScrap"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeScrap"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oee1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oee2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oee3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tcu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalEquipmentTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mannedTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productionTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operatingTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valuedOperatingTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"speedLoss"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scrapLoss"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stopsData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopStats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StopStats"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":525}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/stop-stats.gql\'\\n\\nquery lineConsolidatedOEE($lineIds: [ID!], $time: Time!, $includeScrap: Boolean = true) {\\n  consolidatedData(lineIds: $lineIds, time: $time) {\\n    oee(includeScrap: $includeScrap) {\\n      oee1\\n      oee2\\n      oee3\\n      tcu\\n      totalEquipmentTime\\n      mannedTime\\n      productionTime\\n      operatingTime\\n      valuedOperatingTime\\n      speedLoss\\n      scrapLoss\\n    }\\n\\n    stopsData {\\n      _id: lineId\\n      lineId\\n      stopStats {\\n        ...StopStats\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(80793).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.lineConsolidatedOEE = oneQuery(doc, "lineConsolidatedOEE");
        


/***/ }),

/***/ 88031:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consolidated-lines",
      function () {
        return __webpack_require__(36562);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ MutationButton; },
/* harmony export */   "t": function() { return /* binding */ MutationIconButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14834);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45283);
/* harmony import */ var _mui_material_Fab__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76849);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10016);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81933);
/* harmony import */ var _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4551);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);












var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        buttonMutationLoading: {
            marginRight: theme.spacing(1),
            marginTop: "-2px"
        },
        buttonMutationWithIconLoading: {
            position: "absolute",
            left: "5px"
        },
        iconButtonMutationLoading: {
            marginTop: theme.spacing(0.5),
            marginLeft: "auto",
            marginRight: "auto",
            position: "absolute",
            left: "0",
            right: "0"
        },
        addCustomColor: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.getContrastText(theme.palette.error.main),
            "&:hover": {
                backgroundColor: theme.palette.error.main
            }
        },
        addIconCustomColor: {
            color: theme.palette.error.main
        }
    };
});
var MutationButton = function(_param) {
    var children = _param.children, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _tooltipPlacement = _param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? "top" : _tooltipPlacement, _tooltipMsg = _param.tooltipMsg, tooltipMsg = _tooltipMsg === void 0 ? "" : _tooltipMsg, _tooltipMsgDisabled = _param.tooltipMsgDisabled, tooltipMsgDisabled = _tooltipMsgDisabled === void 0 ? "" : _tooltipMsgDisabled, spanClass = _param.spanClass, loading = _param.loading, onClick = _param.onClick, loadingColor = _param.loadingColor, withIcon = _param.withIcon, variant = _param.variant, overrideProgressStyle = _param.overrideProgressStyle, isRed = _param.isRed, color = _param.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "disabled",
        "tooltipPlacement",
        "tooltipMsg",
        "tooltipMsgDisabled",
        "spanClass",
        "loading",
        "onClick",
        "loadingColor",
        "withIcon",
        "variant",
        "overrideProgressStyle",
        "isRed",
        "color"
    ]);
    var classes = useStyles().classes;
    var ButtonComponent = variant === "fab" ? _mui_material_Fab__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z : variant === "icon" ? _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        placement: tooltipPlacement,
        title: disabled ? tooltipMsgDisabled : tooltipMsg,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "".concat(isRed ? classes.addIconCustomColor : "", " ").concat(spanClass),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ButtonComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, rest), {
                color: color !== null && color !== void 0 ? color : isRed ? "inherit" : "primary",
                disabled: disabled || loading,
                onClick: function(e) {
                    return !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
                },
                children: [
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        size: withIcon ? 32 : 18,
                        className: "".concat(classes.buttonMutationLoading, " ").concat(withIcon ? classes.buttonMutationWithIconLoading : ""),
                        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            color: loadingColor !== null && loadingColor !== void 0 ? loadingColor : _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__/* ["default"][500] */ .Z[500]
                        }, overrideProgressStyle !== null && overrideProgressStyle !== void 0 ? overrideProgressStyle : {})
                    }),
                    children
                ]
            }))
        })
    });
};
/**
 * Quickly set up an `IconButton` wrapped in a `Tooltip` for displaying a message when it's disabled.
 *
 * If a disabled prop has been passed, this will also make sure to block any onClick action, while
 * it is disabled.
 *
 * If a loading prop is passed in, it will automatically handle adding and removing loading spinner
 * around the icon.
 */ var MutationIconButton = function(_param) {
    var children = _param.children, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _tooltipPlacement = _param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? "top" : _tooltipPlacement, _tooltipMsg = _param.tooltipMsg, tooltipMsg = _tooltipMsg === void 0 ? "" : _tooltipMsg, _tooltipMsgDisabled = _param.tooltipMsgDisabled, tooltipMsgDisabled = _tooltipMsgDisabled === void 0 ? "" : _tooltipMsgDisabled, spanClass = _param.spanClass, loading = _param.loading, onClick = _param.onClick, loadingColor = _param.loadingColor, overrideProgressStyle = _param.overrideProgressStyle, isRed = _param.isRed, color = _param.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "disabled",
        "tooltipPlacement",
        "tooltipMsg",
        "tooltipMsgDisabled",
        "spanClass",
        "loading",
        "onClick",
        "loadingColor",
        "overrideProgressStyle",
        "isRed",
        "color"
    ]);
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        placement: tooltipPlacement,
        title: disabled ? tooltipMsgDisabled : tooltipMsg,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "".concat(isRed ? classes.addIconCustomColor : "", " ").concat(spanClass),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    color: color !== null && color !== void 0 ? color : isRed ? "inherit" : "primary"
                }, rest), {
                    disabled: disabled || loading,
                    onClick: function(e) {
                        return !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
                    },
                    size: "large",
                    children: children
                })),
                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    size: 40,
                    className: classes.iconButtonMutationLoading,
                    style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        color: loadingColor !== null && loadingColor !== void 0 ? loadingColor : _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__/* ["default"][500] */ .Z[500]
                    }, overrideProgressStyle !== null && overrideProgressStyle !== void 0 ? overrideProgressStyle : {})
                })
            ]
        })
    });
};


/***/ }),

/***/ 64149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11083);
/* harmony import */ var _mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89703);
/* harmony import */ var _mui_material_ButtonBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);









var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()({
    fadeScrollButton: {
        color: "rgba(0, 0, 0, .1)"
    },
    scrollButton: {
        width: 56,
        flexShrink: 0
    }
});
var ScrollButton = function(props) {
    var className = props.className, onClick = props.onClick, direction = props.direction, visible = props.visible, disabled = props.disabled, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "className",
        "onClick",
        "direction",
        "visible",
        "disabled"
    ]);
    var ref = useStyles(), classes = ref.classes, cx = ref.cx;
    var classNames = disabled ? cx(!visible && classes.fadeScrollButton, classes.scrollButton, className) : cx(classes.scrollButton, className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_ButtonBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: classNames,
        onClick: onClick,
        tabIndex: -1,
        disabled: disabled
    }, other), {
        children: direction === "left" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            fontSize: "large"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            fontSize: "large"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollButton);


/***/ }),

/***/ 17294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ DeviceContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29901);

var DeviceContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    owner: undefined,
    uuid: "",
    index: "0",
    deviceType: "COUNTER",
    NodePicker: undefined,
    lineNodes: [],
    deviceLineId: undefined
});


/***/ }),

/***/ 89506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LineContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29901);

var LineContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    lineId: undefined,
    lineName: undefined
});


/***/ }),

/***/ 80484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ TimepickerContext; },
/* harmony export */   "PZ": function() { return /* binding */ timeSelectionIntervals; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48417);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13515);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10571);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25998);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55412);









var timeSelectionIntervals = [
    {
        time: 30..minutes,
        label: "30m"
    },
    {
        time: 60..minutes,
        label: "1h"
    },
    {
        time: 4..hours,
        label: "4h"
    },
    {
        time: 8..hours,
        label: "8h"
    },
    {
        time: 12..hours,
        label: "12h"
    },
    {
        time: 24..hours,
        label: "24h"
    },
    {
        time: 2 * 24..hours,
        label: "48h"
    },
    {
        time: 7 * 24..hours,
        label: "1w"
    },
    {
        time: 30 * 24..hours,
        label: "1m",
        largeRange: true
    }, 
];
var _timeSelectionIntervals = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(timeSelectionIntervals, 3), ref = _timeSelectionIntervals[2], defaultInterval = ref.time;
var TimepickerContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    from: new Date(Date.now() - 8..hours),
    to: null,
    historySize: 0,
    setTime: Function.prototype,
    // FIXME: Undo is currently done /w a simple queue push/pop
    undo: Function.prototype,
    // FIXME: If redo was to be implemented, determine if we want to implement is
    // a tree or a linear history.
    // redo: Function.prototype,
    relativeTimeInterval: null
});
var TimepickerContextWrapper = function(param) {
    var children = param.children;
    var _ref = (0,_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useURLQuery */ .m)(), tmp = _ref.from, queryFrom = tmp === void 0 ? "" : tmp, tmp1 = _ref.to, queryTo = tmp1 === void 0 ? "" : tmp1, restQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, [
        "from",
        "to"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return [
            new Date(queryFrom).getTime() || NaN,
            new Date(queryTo).getTime() || NaN
        ];
    }, [
        queryFrom,
        queryTo
    ]), queryFromMillis = ref[0], queryToMillis = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(queryFromMillis || Date.now() - 8..hours), from = ref1[0], setFrom = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(queryFromMillis < queryToMillis ? queryToMillis : null), to = ref2[0], setTo = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), history = ref3[0], setHistory = ref3[1];
    var relativeTimeInterval = to ? null : Date.now() - from;
    var setTime = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(start, end) {
        // Ensures from and to are updated at the same time. May be removed in future React versions. https://stackoverflow.com/questions/48563650/does-react-keep-the-order-for-state-updates/48610973#48610973
        (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.unstable_batchedUpdates)(function() {
            setFrom(start.getTime());
            setTo(end && start.getTime() < end.getTime() ? end.getTime() : null);
            setHistory((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(history).concat([
                {
                    from: from,
                    to: to
                }
            ]).slice(-10));
        });
    }, [
        history
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // Ensures from and to are updated at the same time. May be removed in future React versions. https://stackoverflow.com/questions/48563650/does-react-keep-the-order-for-state-updates/48610973#48610973
        (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.unstable_batchedUpdates)(function() {
            if (queryFromMillis && queryFromMillis !== from) {
                setFrom(queryFromMillis);
            }
            if (queryToMillis && queryToMillis !== to) {
                setTo(queryToMillis);
            }
        });
    }, [
        queryFromMillis,
        queryToMillis
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var newFrom = queryFromMillis !== from;
        var newTo = queryToMillis !== to;
        if (!newFrom && !newTo) {
            return;
        }
        var pathname = router.pathname;
        var url = (0,url__WEBPACK_IMPORTED_MODULE_4__.format)({
            pathname: pathname,
            query: [
                {
                    from: from
                },
                {
                    to: to
                }
            ].reduce(function(query, timestamp) {
                var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Object.entries(timestamp), 1), ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ref[0], 2), key = ref1[0], value = ref1[1];
                if (value) {
                    query[key] = new Date(value).toISOString();
                }
                return query;
            }, restQuery)
        });
        router.replace(url, url, {
            shallow: true
        });
    }, [
        from,
        to
    ]);
    var undo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (!history.length) {
            return;
        }
        var cutOff = history.length - 1;
        var ref = [
            history.slice(0, cutOff),
            history.slice(cutOff)
        ], nextHistory = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ref[1], 1), historyItem = ref1[0];
        // Ensures from and to are updated at the same time. May be removed in future React versions. https://stackoverflow.com/questions/48563650/does-react-keep-the-order-for-state-updates/48610973#48610973
        (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.unstable_batchedUpdates)(function() {
            setHistory(nextHistory);
            if (!historyItem) {
                return;
            }
            setFrom(historyItem.from);
            setTo(historyItem.to);
        });
        return historyItem.from;
    }, [
        history
    ]);
    var futureTimeSpan = Math.max(0, (to || 0) - Date.now());
    var fromDate = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return new Date(from);
    }, [
        from,
        futureTimeSpan
    ]);
    var toDate = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return to ? new Date(to) : null;
    }, [
        to,
        futureTimeSpan
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TimepickerContext.Provider, {
        value: {
            from: fromDate,
            to: toDate,
            setTime: setTime,
            historySize: history.length,
            undo: undo,
            relativeTimeInterval: relativeTimeInterval
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (TimepickerContextWrapper);


/***/ }),

/***/ 15608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ millisAsmmss; },
/* harmony export */   "HN": function() { return /* binding */ localDayWithTimezoneOffset; },
/* harmony export */   "KB": function() { return /* binding */ convertPcsPerTimeToWantedUnit; },
/* harmony export */   "MI": function() { return /* binding */ timeFormatVariable; },
/* harmony export */   "Ob": function() { return /* binding */ timeFormatyyyyMMMddhhmmsstimezone; },
/* harmony export */   "Ox": function() { return /* binding */ timeFormatdMMMMhmm; },
/* harmony export */   "Ud": function() { return /* binding */ guardedCallbackString; },
/* harmony export */   "_D": function() { return /* binding */ evaluateWeekSpan; },
/* harmony export */   "_t": function() { return /* binding */ isBrowserLocale24h; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "j0": function() { return /* binding */ toHHMMSS; },
/* harmony export */   "l8": function() { return /* binding */ DateTimeLabelFormatBasedOnBrowserLocale; },
/* harmony export */   "mc": function() { return /* binding */ xDateFormatBasedOnBrowserLocale; },
/* harmony export */   "rr": function() { return /* binding */ timeFormatyyyyMMdd; },
/* harmony export */   "tI": function() { return /* binding */ timeFormatdMMMMyyyyhhmm; },
/* harmony export */   "td": function() { return /* binding */ timeFormatyyyyMMdhmm; },
/* harmony export */   "vw": function() { return /* binding */ guardedCallback; },
/* harmony export */   "wQ": function() { return /* binding */ mod; },
/* harmony export */   "xQ": function() { return /* binding */ excelReadableDateFormat; },
/* harmony export */   "zs": function() { return /* binding */ timeFormatyyyyMMdhmmss; }
/* harmony export */ });
/* unused harmony exports guardedCallbackNumber, timeFormatyyyyMMMMdhmmss, isNewFeature */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88149);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99758);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31650);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30489);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22638);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25955);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52108);





// TODO: Drop the use of this function, it's too simple to keep :p Excel does
// the formatting for us.
var excelReadableDateFormat = function(date) {
    if (!date) {
        return "";
    }
    return new Date(date);
};
var localDayWithTimezoneOffset = function(date) {
    var localDay = new Date(date.getTime() - date.getTimezoneOffset() * 1..minutes);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(localDay.toISOString().split("T"), 1), calendarDay = ref[0];
    return calendarDay;
};
var guardedCallbackNumber = function(callback) {
    return function(param) {
        var value = param.target.value;
        var parsedValue = Number(value);
        if (Number.isNaN(parsedValue)) {
            return;
        }
        return callback(parsedValue);
    };
};
var guardedCallbackString = function(callback) {
    return function(param) {
        var value = param.target.value;
        if (typeof value !== "string") {
            return;
        }
        return callback(value);
    };
};
var guardedCallback = guardedCallbackString;
var mod = function(n, m) {
    return (n % m + m) % m;
};
/**
 * Time Formatting 7/3/2021 13:00 or 3/7/2021 1:00 PM
 * @param time
 */ var timeFormatyyyyMMdhmm = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
function millisAsmmss(ms) {
    var minutes = Math.floor(ms / (60 * 1000));
    var minutesms = ms % (60 * 1000);
    var sec = Math.floor(minutesms / 1000);
    return "".concat(minutes.toLocaleString(undefined, {
        minimumIntegerDigits: 2
    }), ":").concat(sec.toLocaleString(undefined, {
        minimumIntegerDigits: 2
    }));
}
/**
 * Time Formatting 7/3/2021 13:00:00 or 3/7/2021 1:00:00 PM
 * @param time
 */ var timeFormatyyyyMMdhmmss = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7. marts 13:00 or March 7, 1:00 PM
 * @param time
 */ var timeFormatdMMMMhmm = function(time, locale) {
    var genericTimeFormat = {
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7. marts 2021 13:00 or March 7, 2021, 1:00 PM
 * @param time
 */ var timeFormatdMMMMyyyyhhmm = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7/3/2021 or 3/7/2021
 * @param time
 */ var timeFormatyyyyMMdd = function(time, locale) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(time, Date) === false || isNaN(time.getTime())) {
        console.error("!Error: Parameter time was not an instane of date!");
        return "Invalid Date!";
    }
    var genericTimeFormat = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7/3/2021 13:00:00 or 3/7/2021 1:00:00 PM
 * @param time
 */ var timeFormatyyyyMMMMdhmmss = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "short",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    };
    return intlFormat(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting:
 * Wed, 7. Mar, 2021, 13:00:00 Central European Standard time
 * or
 * Wed, Mar 7, 2021, 1:00:00 PM Central European Standard time
 * @param time
 */ var timeFormatyyyyMMMddhhmmsstimezone = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "long"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
var isBrowserLocale24hCache = {};
/**
 * return true if locale in browser is 24h format
 */ var isBrowserLocale24h = function(language) {
    if (isBrowserLocale24hCache.hasOwnProperty(language)) {
        return isBrowserLocale24hCache[language];
    } else {
        var res = !new Intl.DateTimeFormat(language || navigator.language, {
            hour: "numeric"
        }).format(0).match(/AM|PM/);
        isBrowserLocale24hCache[language] = res;
        return res;
    }
};
/**
 * Time Formatting Monday, 15. Mar, 2021 - 13:00:00.000 or Monday, Mar 15, 2021 - 01:00:00.000 PM
 */ var xDateFormatBasedOnBrowserLocale = function(language) {
    if (isBrowserLocale24h(language)) {
        return "%A, %b %e, %Y - %H:%M:%S.%L";
    }
    return "%A, %e. %b, %Y - %I:%M:%S.%L%p";
};
/**
 * Time Formatting adds AM/PM formatting if browser locale is AM/PM
 */ var DateTimeLabelFormatBasedOnBrowserLocale = function(language) {
    var formats = {};
    if (isBrowserLocale24h(language)) {
        formats = {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H:%M",
            day: "%e. %b",
            week: "%e. %b",
            month: "%e. %b",
            year: "%b"
        };
    } else {
        formats = {
            millisecond: "%I:%M:%S.%L%p",
            second: "%I:%M:%S%p",
            minute: "%I:%M%p",
            hour: "%I:%M%p",
            day: "%b %e",
            week: "%b %e",
            month: "%b %e",
            year: "%b"
        };
    }
    return formats;
};
/**
 * Note: Format this way, instead of using date-fns, because date-fns format is timezone aware,
 * resulting in format(0, 'HH:mm:ss') = '01:00:00' for GMT+1.
 */ var toHHMMSS = function(v) {
    var secNum = Math.abs(Math.floor(v / 1000));
    var hours = Math.floor(secNum / 3600);
    var minutes = Math.floor((secNum - hours * 3600) / 60);
    var seconds = secNum - hours * 3600 - minutes * 60;
    hours = hours === 0 || isNaN(hours) ? "00" : (hours < 10 ? "0" : "") + "".concat(hours);
    minutes = minutes === 0 || isNaN(minutes) ? "00" : (minutes < 10 ? "0" : "") + "".concat(minutes);
    seconds = seconds === 0 || isNaN(seconds) ? "00" : (seconds < 10 ? "0" : "") + "".concat(seconds);
    var fs = hours + ":" + minutes + ":" + seconds;
    return v < 0 ? "-".concat(fs) : "".concat(fs);
};
/**
 * if i=14 it returns 14:00 or 2:00 PM depending on browser locale
 * @param i
 */ var timeFormatVariable = function(i, language) {
    if (isBrowserLocale24h(language)) {
        return i + ":00";
    } else {
        var timeString = "";
        if (i % 12 !== 0) {
            timeString = (i % 12).toString();
        } else {
            timeString = 12..toString();
        }
        if (i > 11) {
            timeString = timeString + ":00 PM";
        } else {
            timeString = timeString + ":00 AM";
        }
        return timeString;
    }
};
/**
 * turns number of pcs per time into wanted time unit (min/hour/day)
 */ var convertPcsPerTimeToWantedUnit = function(noOfPcs, currentUnit, wantedUnit) {
    var pcsPerMin = 0;
    //Convert pcs/currentUnit into pcs/min
    switch(currentUnit){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.DAY */ .cW.DAY:
            pcsPerMin = noOfPcs / 60 / 24;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            pcsPerMin = noOfPcs / 60;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.MINUTE */ .cW.MINUTE:
            pcsPerMin = noOfPcs;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_4__/* .assertUnreachable */ .U(currentUnit);
            break;
    }
    //Convert pcs/min into pcs/wantedUnit
    var pcsPerWantedUnit = 0;
    switch(wantedUnit){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.DAY */ .cW.DAY:
            pcsPerWantedUnit = pcsPerMin * 60 * 24;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            pcsPerWantedUnit = pcsPerMin * 60;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.MINUTE */ .cW.MINUTE:
            pcsPerWantedUnit = pcsPerMin;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_4__/* .assertUnreachable */ .U(wantedUnit);
            break;
    }
    return pcsPerWantedUnit;
};
var isNewFeature = function(releaseTime) {
    var age = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 7..days;
    return Date.now() <= new Date(releaseTime).getTime() + age;
};
function sleep(milliseconds) {
    return new Promise(function(r) {
        return setTimeout(r, milliseconds);
    });
}
var evaluateWeekSpan = function(date) {
    var dateCopy = new Date(date);
    dateCopy.setHours(0, 0, 0, 0);
    var monday = (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(dateCopy, 1);
    var mondayNextWeek = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(monday);
    return [
        monday,
        mondayNextWeek
    ];
};


/***/ }),

/***/ 36562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ consolidated_lines; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/index.js
var client = __webpack_require__(62523);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ./components/bars/groups-sidebar.tsx
var groups_sidebar = __webpack_require__(66889);
// EXTERNAL MODULE: ./contexts/timepicker.tsx
var timepicker = __webpack_require__(80484);
// EXTERNAL MODULE: ./graphql/queries/consolidated-groups-lines.gql
var consolidated_groups_lines = __webpack_require__(65342);
var consolidated_groups_lines_default = /*#__PURE__*/__webpack_require__.n(consolidated_groups_lines);
// EXTERNAL MODULE: ./helpers/schedule.ts
var schedule = __webpack_require__(40510);
// EXTERNAL MODULE: ./hooks/use-iam.tsx
var use_iam = __webpack_require__(12872);
// EXTERNAL MODULE: ./types/helper-types.ts
var helper_types = __webpack_require__(52108);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(2716);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(58797);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(53435);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormGroup/FormGroup.js
var FormGroup = __webpack_require__(69049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(23667);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Switch/Switch.js
var Switch = __webpack_require__(85309);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(33542);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/memoize.js
var memoize = __webpack_require__(67997);
var memoize_default = /*#__PURE__*/__webpack_require__.n(memoize);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/mean.js
var mean = __webpack_require__(75801);
var mean_default = /*#__PURE__*/__webpack_require__.n(mean);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ./components/buttons/live-data-button.tsx
var live_data_button = __webpack_require__(71813);
// EXTERNAL MODULE: ./components/loading/loading-or-error.tsx
var loading_or_error = __webpack_require__(89879);
// EXTERNAL MODULE: ./components/pickers/time-picker.tsx
var time_picker = __webpack_require__(29876);
// EXTERNAL MODULE: ./graphql/queries/line-consolidated-oee.gql
var line_consolidated_oee = __webpack_require__(92051);
var line_consolidated_oee_default = /*#__PURE__*/__webpack_require__.n(line_consolidated_oee);
// EXTERNAL MODULE: ./hooks/use-translation.tsx
var use_translation = __webpack_require__(59721);
// EXTERNAL MODULE: ./lib/hash.ts
var hash = __webpack_require__(34614);
// EXTERNAL MODULE: ./types/index.ts
var types = __webpack_require__(24877);
// EXTERNAL MODULE: ./views/tabs/oee/oee-kpi-card.tsx + 1 modules
var oee_kpi_card = __webpack_require__(70912);
// EXTERNAL MODULE: ./views/tabs/oee/oee-table-card.tsx
var oee_table_card = __webpack_require__(74831);
// EXTERNAL MODULE: ./views/tabs/oee/oee-waterfall-card.tsx + 1 modules
var oee_waterfall_card = __webpack_require__(26946);
;// CONCATENATED MODULE: ./views/consolidated-lines/consolidated-oee-grid.tsx


























var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        card: {
            width: "100%",
            minHeight: "70px"
        },
        loadingCardContent: {
            height: "200px"
        },
        flexContainer: {
            display: "flex"
        },
        includeScrapButton: {
            marginLeft: theme.spacing(2)
        }
    };
});
var getWaterfallStatsFromStopData = function(stopsData) {
    return stopsData.reduce(function(stopStats, cur) {
        var _stopStats;
        (_stopStats = stopStats).push.apply(_stopStats, (0,_to_consumable_array/* default */.Z)(cur.stopStats.stopCauseStats.filter(helper_types/* isTruthy */.f)));
        return stopStats;
    }, []);
};
var memoizedFallbackTo = memoize_default()(function(to) {
    return to || new Date();
}, function(to) {
    return "".concat(to === null || to === void 0 ? void 0 : to.getTime());
});
var ConsolidatedOEELineGrid = function(param) {
    var lines = param.lines;
    var ref, ref1;
    var ref2 = (0,react.useState)(true), includeScrap = ref2[0], setIncludeScrap = ref2[1];
    var ref3 = useStyles(), classes = ref3.classes, theme = ref3.theme;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,use_translation/* useTranslation */.$)(), 1), t = ref4[0];
    var ref5 = (0,react.useState)(""), dataHash = ref5[0], setDataHash = ref5[1];
    var ref6 = (0,react.useContext)(timepicker/* TimepickerContext */.Ai), from = ref6.from, to = ref6.to, setTime = ref6.setTime;
    var fallbackTo = memoizedFallbackTo(to);
    var timeRange = {
        from: from,
        to: fallbackTo
    };
    var toggleScrap = function() {
        setIncludeScrap(!includeScrap);
        refetch();
    };
    var ref7 = (0,client.useQuery)((line_consolidated_oee_default()), {
        ssr: false,
        partialRefetch: true,
        errorPolicy: "all",
        onCompleted: (0,hash/* updateDataHash */.G)(setDataHash),
        variables: {
            lineIds: lines.map(function(line) {
                return line.id;
            }),
            time: types/* toISOString */.Y6(timeRange),
            includeScrap: includeScrap
        }
    }), data = ref7.data, loading = ref7.loading, error = ref7.error, refetch = ref7.refetch;
    var oee = (data === null || data === void 0 ? void 0 : (ref = data.consolidatedData) === null || ref === void 0 ? void 0 : ref.oee) || null;
    var ref8 = oee || {
        oee1: 0,
        oee2: 0,
        oee3: 0,
        tcu: 0
    }, oee1 = ref8.oee1, oee2 = ref8.oee2, oee3 = ref8.oee3, tcu = ref8.tcu;
    var ref9;
    var stopsData = ((ref9 = data === null || data === void 0 ? void 0 : (ref1 = data.consolidatedData) === null || ref1 === void 0 ? void 0 : ref1.stopsData) !== null && ref9 !== void 0 ? ref9 : []).filter(function(item) {
        return !!item;
    });
    var stopStats = getWaterfallStatsFromStopData(stopsData);
    var smallDown = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("xs"));
    var fullLoading = !!oee ? false : loading;
    var chartLoading = loading;
    var includeScrapButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                value: "with-scrap",
                color: "primary",
                checked: includeScrap,
                onClick: toggleScrap
            }),
            label: t([
                "shared:includeScrap"
            ], {
                defaultValue: "Include scrap"
            }),
            disabled: loading
        })
    });
    var targets = lines.reduce(function(aggregatedTargets, line) {
        var ref;
        var weeklyTargets = (ref = line.schedule) === null || ref === void 0 ? void 0 : ref.weeklyTargets;
        if (!weeklyTargets) {
            return aggregatedTargets;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(weeklyTargets)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), kpi = _value[0], targetValue = _value[1];
                if (typeof targetValue === "number") {
                    aggregatedTargets[kpi].push(targetValue);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return aggregatedTargets;
    }, {
        oee: [],
        oee2: [],
        oee3: [],
        tcu: []
    });
    var oee1Target = targets.oee.length ? mean_default()(targets.oee) : undefined;
    var oee2Target = targets.oee2.length ? mean_default()(targets.oee2) : undefined;
    var oee3Target = targets.oee3.length ? mean_default()(targets.oee3) : undefined;
    var tcuTarget = targets.tcu.length ? mean_default()(targets.tcu) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 1,
        alignItems: "stretch",
        justifyContent: "flex-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    className: classes.card,
                    elevation: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                smallDown ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.flexContainer,
                                    style: {
                                        justifyContent: "space-between"
                                    },
                                    children: [
                                        includeScrapButton,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(live_data_button/* default */.Z, {
                                            loading: loading
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.flexContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(time_picker/* default */.Z, {
                                            includeLargeRanges: true
                                        }),
                                        smallDown ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                includeScrapButton,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(live_data_button/* default */.Z, {
                                                    loading: loading
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            fullLoading || error && !data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    elevation: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                        classes: {
                            root: classes.loadingCardContent
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                            loading: fullLoading,
                            error: error
                        })
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                        loading: false,
                        error: error,
                        data: data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_kpi_card/* default */.Z, {
                        gaugeColor: theme.blackbird.stops.NO_ACT.color.normal,
                        title: "TCU",
                        value: tcu,
                        targetValue: tcuTarget
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_kpi_card/* default */.Z, {
                        gaugeColor: theme.blackbird.stops.NON_PROD.color.normal,
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "OEE",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sub", {
                                    children: "3"
                                })
                            ]
                        }),
                        value: oee3,
                        targetValue: oee3Target
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_kpi_card/* default */.Z, {
                        gaugeColor: theme.blackbird.stops.BATCH_NON_PROD.color.normal,
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "OEE",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sub", {
                                    children: "2"
                                })
                            ]
                        }),
                        value: oee2,
                        targetValue: oee2Target
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_kpi_card/* default */.Z, {
                        gaugeColor: theme.blackbird.stops.DOWNTIME.color.normal,
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "OEE",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sub", {
                                    children: "1"
                                })
                            ]
                        }),
                        value: oee1,
                        targetValue: oee1Target
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_waterfall_card/* default */.Z, {
                data: {
                    timeRange: types/* toISOString */.Y6(timeRange),
                    oee: oee,
                    stopStats: stopStats
                },
                dataHash: dataHash,
                refetch: setTime,
                loading: chartLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(oee_table_card/* default */.Z, {
                data: {
                    timeRange: types/* toISOString */.Y6(timeRange),
                    oee: oee,
                    stopStats: stopStats
                },
                refetch: setTime
            })
        ]
    });
};
/* harmony default export */ var consolidated_oee_grid = (ConsolidatedOEELineGrid);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.11.16_@types+react@17.0.53_react@17.0.2/node_modules/@mui/icons-material/GroupWork.js
var GroupWork = __webpack_require__(43430);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.11.16_@types+react@17.0.53_react@17.0.2/node_modules/@mui/icons-material/ArrowForward.js
var ArrowForward = __webpack_require__(20435);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.11.16_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.53_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(94941);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js + 2 modules
var Recompose_esm = __webpack_require__(14895);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
;// CONCATENATED MODULE: ./views/consolidated-lines/no-group-selected.tsx











var styles = function(theme) {
    return {
        container: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            width: "100%",
            flexDirection: "column"
        },
        message: {
            paddingBottom: theme.spacing(2),
            maxWidth: "300px"
        },
        icon: {
            height: "100px",
            width: "100px",
            paddingBottom: theme.spacing(2)
        }
    };
};
var NoGroupSelected = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(NoGroupSelected, _Component);
    var _super = (0,_create_super/* default */.Z)(NoGroupSelected);
    function NoGroupSelected() {
        (0,_class_call_check/* default */.Z)(this, NoGroupSelected);
        return _super.apply(this, arguments);
    }
    var _proto = NoGroupSelected.prototype;
    _proto.render = function render() {
        var _props = this.props, t = _props.t, classes = _props.classes;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupWork/* default */.Z, {
                    className: classes.icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h6",
                    className: classes.message,
                    children: t([
                        "line:noGroupSelected"
                    ], {
                        defaultValue: "No group selected"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    align: "center",
                    variant: "subtitle1",
                    className: classes.message,
                    children: t([
                        "line:selectAGroupToSeeConsolidatedOee"
                    ], {
                        defaultValue: "Select a group in the menu to the right to see consolidated OEE"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                    fontSize: "large"
                })
            ]
        });
    };
    return NoGroupSelected;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared",
    "line"
]), (0,with_styles/* withStyles */.D)(styles));
/* harmony default export */ var no_group_selected = (enhance(NoGroupSelected));

;// CONCATENATED MODULE: ./views/consolidated-lines/consolidated-lines-page.tsx











var thisWeek = (0,schedule/* getYearWeek */.dl)(new Date());
var ConsolidatedLinesPage = function() {
    var ref = (0,react.useState)(null), selectedGroupId = ref[0], setSelectedGroupId = ref[1];
    var hasGroupFeatures = (0,use_iam/* useIAM */.e)().hasGroupFeatures;
    var ref1 = (0,client.useQuery)((consolidated_groups_lines_default()), {
        partialRefetch: true,
        errorPolicy: "all",
        ssr: false,
        variables: {
            validIn: thisWeek
        }
    }), loading = ref1.loading, data = ref1.data;
    var onSelectGroup = function(groupId) {
        return setSelectedGroupId(groupId);
    };
    var _groups;
    var groupsWithLines = ((_groups = data === null || data === void 0 ? void 0 : data.user.groups) !== null && _groups !== void 0 ? _groups : []).filter(function(group) {
        return group.lines.length;
    }).filter(function(g) {
        return hasGroupFeatures(g.id, [
            "Lines.Line"
        ], "Q");
    });
    var selectedGroup = groupsWithLines.find(function(group) {
        return group.id === selectedGroupId;
    }) || null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            position: "relative",
            height: "100%"
        },
        children: [
            selectedGroup ? /*#__PURE__*/ (0,jsx_runtime.jsx)(timepicker/* default */.ZP, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(consolidated_oee_grid, {
                    lines: selectedGroup.lines.filter(helper_types/* isTruthy */.f)
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(no_group_selected, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(groups_sidebar/* default */.Z, {
                selectedGroupId: selectedGroupId,
                groups: groupsWithLines,
                groupsLoading: loading,
                onSelectGroup: onSelectGroup
            })
        ]
    });
};
/* harmony default export */ var consolidated_lines_page = (ConsolidatedLinesPage);

;// CONCATENATED MODULE: ./pages/consolidated-lines/index.tsx


var ConsolidatedLines = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(consolidated_lines_page, {});
};
var __N_SSG = true;
/* harmony default export */ var consolidated_lines = (ConsolidatedLines);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7318,2742,7773,6355,9238,5566,6174,3952,8723,8563,3417,4211,6105,1964,3917,2919,9823,1741,9774,2888,179], function() { return __webpack_exec__(88031); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);